var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"ma-4"},[_c('v-card-title',{staticClass:"mb-3"},[_c('h2',[_vm._v(_vm._s(_vm.item.name)+" ("+_vm._s(_vm.item.shortName)+")")])])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }